import app from 'flarum/forum/app';
function normalizedDraftCount(value) {
  return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, value) : 0;
}
export function getDraftCount() {
  var _app$session$user, _app$session$user$dra;
  return normalizedDraftCount((_app$session$user = app.session.user) == null || (_app$session$user$dra = _app$session$user.draftCount) == null ? void 0 : _app$session$user$dra.call(_app$session$user));
}
export function setDraftCount(count) {
  var _user$data;
  const user = app.session.user;
  if (!(user != null && (_user$data = user.data) != null && _user$data.attributes)) {
    return;
  }
  user.data.attributes.draftCount = normalizedDraftCount(count);
}
export function adjustDraftCount(delta) {
  setDraftCount(getDraftCount() + delta);
}
flarum.reg.add('fof-drafts', 'forum/utils/draftCount', { getDraftCount: getDraftCount,setDraftCount: setDraftCount,adjustDraftCount: adjustDraftCount, });